import React, { useState } from "react";

import {
  Heading,
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Text,
  useColorModeValue,
  useColorMode,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

import { useSelector } from "react-redux";

import { BsChevronDown } from "react-icons/bs";
import {
  AiOutlineCloudUpload,
  AiOutlineSearch,
  AiOutlineUserAdd,
} from "react-icons/ai";

import { HiUserGroup } from "react-icons/hi";

import { SiMicrosoftexchange } from "react-icons/si";

import { useDispatch } from "react-redux";
import { is_search } from "../../redux/actions/utilActions";

import Filters from "./Filters";
import { useEffect } from "react";

const ProspectHeader = ({ addOnOpen, onBulkOpen, filter, setFilter }) => {
  const activevariant = useColorModeValue("primary", "secondary");
  const { colorMode } = useColorMode();

  const dispatch = useDispatch();
  const leads = useSelector((state) => state.prospects.prospects);
  const totalProspects = useSelector((state) => state.prospects.totalProspects);

  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(is_search(search));
  }, [search]);

  return (
    <Box>
      <Heading as="h1" size="lg" mb="5" noOfLines={1} mt="20px">
        Prospects
      </Heading>
      <Flex alignItems="center" mb="5">
        <Text size="md" mr="2">
          Leads
        </Text>
        <Button
          leftIcon={<HiUserGroup />}
          variant="solid"
          borderRadius="full"
          size="sm"
          fontWeight={400}
        >
          {totalProspects && totalProspects}
        </Button>
      </Flex>
      <Flex direction="row" mb="5">
        {/* Search bar */}
        <InputGroup mr="2">
          <InputLeftElement
            color={colorMode == "light" ? "#FE9203" : "#FFF"}
            pointerEvents="none"
            children={<AiOutlineSearch color="inherit" size={"25"} />}
          />
          <Input
            type="text"
            placeholder="Search"
            // bg="blue.tertiary"
            borderWidth={2}
            borderColor={colorMode == "light" ? "#FE9203" : "#FFF"}
            // bg={colorMode == "light" ? "transparent" : "#FFF"}
            color={colorMode == "light" ? "#FE9203" : "#FFF"}
            defaultValue={search}
            onKeyDown={(e) => e.key == "Enter" && setSearch(e.target.value)}
          />
        </InputGroup>
        <Menu>
          {/* colorMode == "light" */}
          <MenuButton
            style={{
              background: colorMode == "light" ? "#FE9203" : "#FFF",
              color: colorMode == "light" ? "#000" : "#212138",
            }}
            as={Button}
            iconSpacing={4}
            rightIcon={<BsChevronDown size={"15"} />}
          >
            Actions
          </MenuButton>

          <MenuList>
            <MenuItem
              onClick={addOnOpen}
              icon={<AiOutlineUserAdd size="20" color="#FFF" />}
            >
              Add New
            </MenuItem>
            <MenuItem
              onClick={onBulkOpen}
              icon={<SiMicrosoftexchange size="20" />}
            >
              Bulk Import
            </MenuItem>
          </MenuList>
        </Menu>
        {/* <Button
          leftIcon={<AiOutlineUserAdd color="inherit" size={"25"} />}
          variant="solid"
          onClick={onOpen}
        >
          Prospect
        </Button> */}
      </Flex>
      <Filters />
    </Box>
  );
};

export default ProspectHeader;
